var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWarningCircleNormal = function SvgIcWarningCircleNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.143 25.5c0 12.23-9.914 22.143-22.143 22.143-12.23 0-22.143-9.914-22.143-22.143C2.857 13.27 12.771 3.357 25 3.357c12.23 0 22.143 9.914 22.143 22.143Zm2.857 0c0 13.807-11.193 25-25 25S0 39.307 0 25.5 11.193.5 25 .5s25 11.193 25 25ZM26.429 14.786V29.07a1.429 1.429 0 1 1-2.858 0V14.786a1.429 1.429 0 1 1 2.858 0Zm0 20.714a1.429 1.429 0 1 1-2.858 0 1.429 1.429 0 0 1 2.858 0Z",
    fill: "#D62343"
  })));
};
export default SvgIcWarningCircleNormal;